import {
  optionItemElementLabel,
  optionItemElementLabelMain,
  optionItemElementSublabel
} from '~/components/Form/Input/Dropdown.css'
import { formatName } from '~/utils/names'
import type { ContactTypeFlags } from '../contactTypes'
import { ContactTypeIcons } from './ContactTypeIcons'
import { contactTypeLabel } from './ContactTypeIcons.css'

type Props = {
  contact: {
    firstname?: string | null
    lastname?: string | null
    role?: { name: string }
    customRole?: string
  } & Partial<ContactTypeFlags>
}

export const ContactDropdownOption = ({ contact }: Props) => {
  const role = contact.role?.name || contact.customRole

  return (
    <div className={optionItemElementLabel}>
      <div className={optionItemElementLabelMain}>
        <span className={contactTypeLabel}>
          {formatName(contact)}
          <ContactTypeIcons contact={contact} />
        </span>
      </div>
      {role && <div className={optionItemElementSublabel}>{role}</div>}
    </div>
  )
}
